import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DistributionPicker from '../distribution_picker_component_zoid';
import Lightbox from 'js/components/lightbox';

export default class AddStoryDistributionModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onToggleShown: PropTypes.func.isRequired,
        social_user_id: PropTypes.string,
        campaign_platform_type: PropTypes.string.isRequired,
        campaignId: PropTypes.number
    };

    constructor() {
        super();
        this.state = {
            isSaveInProcess: false
        };
    }

    onCloseModal = () => {
        const {onToggleShown} = this.props;
        onToggleShown();
    };

    startSaveProcess = () => {
        this.setState({
            isSaveInProcess: true
        });
    };

    finishSaveProcess = () => {
        this.setState({
            isSaveInProcess: false
        });
    };

    render() {
        const {show, social_user_id, content_metadata_id, campaignId} = this.props;

        if (!show) {
            return <div />;
        }

        return (
            <Lightbox
                onClose={this.onCloseModal}
                isCloseDisabled={this.state.isSaveInProcess}
                className="snclient_distribution_picker_lightbox"
            >
                <div className="snclient_zoid_component__distribution-picker-wrapper">
                    <DistributionPicker
                        application="admin_brand"
                        contentId={content_metadata_id}
                        campaignId={campaignId}
                        socialAccountId={social_user_id}
                        onSaveStarted={() => this.startSaveProcess()}
                        onSaveFinished={() => this.finishSaveProcess()}
                    />
                </div>
            </Lightbox>
        );
    }
}



// WEBPACK FOOTER //
// ./approval_queues/components/content_review/list_view/content_row/add_story_distribution_modal/index.js